export var LABEL_PREFIX = 'View';
export var DEFAULT_BUTTON_LABEL = 'Menu';